import Vue from "vue";
import Loading from "element-ui/lib/loading";
import Message from "element-ui/lib/message";
import Container from "element-ui/lib/container";
import Header from "element-ui/lib/header";
import Aside from "element-ui/lib/aside";
import Main from "element-ui/lib/main";
import Menu from "element-ui/lib/menu";
import Submenu from "element-ui/lib/submenu";
import MenuItem from "element-ui/lib/menu-item";
import Button from "element-ui/lib/button";
import Form from "element-ui/lib/form";
import FormItem from "element-ui/lib/form-item";
import Input from "element-ui/lib/input";
import Table from "element-ui/lib/table";
import TableColumn from "element-ui/lib/table-column";
import Select from "element-ui/lib/select";
import Option from "element-ui/lib/option";
import Row from "element-ui/lib/row";
import Col from "element-ui/lib/col";
import Tag from "element-ui/lib/tag";
import Avatar from "element-ui/lib/avatar";
import Dropdown from "element-ui/lib/dropdown";
import DropdownMenu from "element-ui/lib/dropdown-menu";
import DropdownItem from "element-ui/lib/dropdown-item";
import Upload from "element-ui/lib/upload";
import Dialog from "element-ui/lib/dialog";
import Pagination from "element-ui/lib/pagination";
import DatePicker from "element-ui/lib/date-picker";
import Alert from "element-ui/lib/alert";
import Checkbox from "element-ui/lib/checkbox";
import InputNumber from "element-ui/lib/input-number";
import Steps from "element-ui/lib/steps";
import Step from "element-ui/lib/step";
import Descriptions from "element-ui/lib/descriptions";
import DescriptionsItem from "element-ui/lib/descriptions-item";

import "element-ui/lib/theme-chalk/base.css";
import "element-ui/lib/theme-chalk/container.css";
import "element-ui/lib/theme-chalk/header.css";
import "element-ui/lib/theme-chalk/aside.css";
import "element-ui/lib/theme-chalk/main.css";
import "element-ui/lib/theme-chalk/menu.css";
import "element-ui/lib/theme-chalk/submenu.css";
import "element-ui/lib/theme-chalk/menu-item.css";
import "element-ui/lib/theme-chalk/button.css";
import "element-ui/lib/theme-chalk/form.css";
import "element-ui/lib/theme-chalk/form-item.css";
import "element-ui/lib/theme-chalk/input.css";
import "element-ui/lib/theme-chalk/table.css";
import "element-ui/lib/theme-chalk/table-column.css";
import "element-ui/lib/theme-chalk/select.css";
import "element-ui/lib/theme-chalk/option.css";
import "element-ui/lib/theme-chalk/row.css";
import "element-ui/lib/theme-chalk/col.css";
import "element-ui/lib/theme-chalk/tag.css";
import "element-ui/lib/theme-chalk/avatar.css";
import "element-ui/lib/theme-chalk/dropdown.css";
import "element-ui/lib/theme-chalk/dropdown-menu.css";
import "element-ui/lib/theme-chalk/dropdown-item.css";
import "element-ui/lib/theme-chalk/upload.css";
import "element-ui/lib/theme-chalk/dialog.css";
import "element-ui/lib/theme-chalk/pagination.css";
import "element-ui/lib/theme-chalk/date-picker.css";
import "element-ui/lib/theme-chalk/alert.css";
import "element-ui/lib/theme-chalk/checkbox.css";
import "element-ui/lib/theme-chalk/input-number.css";
import "element-ui/lib/theme-chalk/steps.css";
import "element-ui/lib/theme-chalk/step.css";
import "element-ui/lib/theme-chalk/descriptions.css";
import "element-ui/lib/theme-chalk/descriptions-item.css";
import "element-ui/lib/theme-chalk/loading.css";
import "element-ui/lib/theme-chalk/message.css";

Vue.use(Container);
Vue.use(Header);
Vue.use(Aside);
Vue.use(Main);
Vue.use(Menu);
Vue.use(Submenu);
Vue.use(MenuItem);
Vue.use(Button);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Select);
Vue.use(Option);
Vue.use(Row);
Vue.use(Col);
Vue.use(Tag);
Vue.use(Avatar);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Upload);
Vue.use(Dialog);
Vue.use(Pagination);
Vue.use(DatePicker);
Vue.use(Alert);
Vue.use(Checkbox);
Vue.use(InputNumber);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Descriptions);
Vue.use(DescriptionsItem);
Vue.use(Loading.directive);

Vue.prototype.$ELEMENT = { size: "small" };
Vue.prototype.$message = Message;
